const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  URL: process.env.REACT_APP_URL || 'http://localhost:3000',
  CONTACT_EMAIL: process.env.REACT_APP_CONTACT_EMAIL || 'tunisian.xp.database@gmail.com',
};

export default config;